export const GQL_GET_REPORTING_ACTIVITIES = `
  query GetReportingActivities($studentId: String!, $dateRange: DateRangeFilter, $locale: Locale, $equated: Boolean) {
    getReportingActivities(
      studentId: $studentId
      dateRange: $dateRange
      equatedScores: $equated
      locale: $locale)
    {
      activityId
      studentId,
      student {
        firstName
        lastName
        grade
        studentId
      }
      story {
        title
        grade
        tags
      }
      createdAt
      updatedAt
      sessionTime
      errors
      status
      displayStatus
      score
      score_pass
      scores {
        areaScore
        armScore
        armScoreAdjusted
        armScorePR
        bkScore
        bkScore_PR
        compScore
        compScore_PR
        currentArmEstimate
        decodeScore
        decodeScore_PR
        dra
        dyslexiaRanTime
        dyslexiaRiskCategory
        dyslexiaRiskIndicator
        equatedWCPM
        equatedWCPMPR
        esriScore
        esriScore_PR
        ISIP_overall_ISIPAR
        ISIP_overall_ISIPAR_PR
        ISIP_overall_universal
ISIP_overall_universal_PR
        lkScore
        phonAwareScore
        phonAwareScore_PR
        ranSpeed
        spellingScore
        vocabSize
        vocabularyScreenerScore
        vocabularyScreenerScore_PR
        wcpmScore
      }
      scoreEstimates{
        ARM_estimate
      }
      children{
        type
        errors
        status
        displayStatus
        activityId
        scores {
          predWcpm
          armScore
        }
      }
      comprehensionDialog {
        phraseIndex
      }
      tags
      type
    }
  }`;

export default GQL_GET_REPORTING_ACTIVITIES;
